var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDigital(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_159_7751)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.1299 19.42C50.5261 19.42 54.0899 15.8562 54.0899 11.46C54.0899 7.06381 50.5261 3.5 46.1299 3.5C41.7337 3.5 38.1699 7.06381 38.1699 11.46C38.1699 15.8562 41.7337 19.42 46.1299 19.42Z",
    stroke: "white",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.7598 17.09L56.3698 21.7",
    stroke: "white",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.2799 40.88C33.2799 46.96 32.01 49.99 29.7 55.62",
    stroke: "white",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.81 31.67C27.37 27.83 21.48 27.5 17.63 30.93C15.65 32.7 14.52 35.23 14.52 37.89C14.52 42.63 13.32 47.3 11.02 51.45",
    stroke: "white",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6299 20.29C27.3599 16.86 38.0199 21.97 41.4499 31.7C42.1499 33.69 42.5099 35.78 42.5099 37.89C42.5099 42.08 42.0499 46.25 41.1199 50.33",
    stroke: "white",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.5 45.67C4.62 43.23 5.2 40.58 5.19 37.89C5.19 32.58 7 28.5 10.5 25",
    stroke: "white",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4699 53.44C20.0799 54.3 19.6599 55.14 19.1899 55.97",
    stroke: "white",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.85 37.89C23.85 41.04 24.05 42.29 23.27 45.34",
    stroke: "white",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_159_7751"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 57.87,
    height: 57.47,
    fill: "white",
    transform: "translate(1 1)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDigital);
export default __webpack_public_path__ + "static/media/digital.33e209853601d133524b09b95abbe49a.svg";
export { ForwardRef as ReactComponent };